import React, { Component } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, MenuItem
} from '@mui/material';
import axios from 'axios';
import TablePagination from '@mui/material/TablePagination';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';

class RequesatQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quoteData: [],
      allServices: [],  // store all services here
loading:true,
      // Pagination
     totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      itemsPerPageOptions: [5, 10, 20],

      // Search fields
      searchName: '',
      searchEmail: '',
      searchPhone: '',
      searchService: '',
    };
  }

  componentDidMount() {
	  document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchAllServices();
    this.fetchQuotes();
  }

  
  fetchAllServices = () => {
  axios.get(Serverurl+'servicemanagement/servicemanagementgetall')
    .then(res => {
      console.log("Service API Response:", res.data); 
      this.setState({ allServices: res.data });
    })
    .catch(err => {
      console.error('Error fetching services:', err);
    });
};


  fetchQuotes = () => {
	   const { page, rowsPerPage } = this.state;
	     this.setState({ loading: true });
    axios.get(`${Serverurl}requestaquote/requestgetall?page=${page}&limit=${rowsPerPage}`)
      .then(res => {
         const { data, totalItems } = res.data;
        this.setState({ quoteData: data, totalItems, loading: false });
      })
      .catch(err => console.error('Error fetching quotes:', err));
  };


 

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

 handleSearch = () => {
  const { searchName, searchEmail, searchPhone, searchService, page, rowsPerPage } = this.state;

  const params = {
    page,
    limit: rowsPerPage,
    name: searchName,
    email: searchEmail,
    phone: searchPhone,
    service: searchService
  };

  axios.get(Serverurl+'requestaquote', { params })
    .then(res => {
      this.setState({
        quoteData: res.data.data,
        totalItems: res.data.totalItems,
        page: 0
      });
    })
    .catch(err => console.error('Error fetching quotes:', err));
};



  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchQuotes);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchQuotes);
  };

  render() {
	  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
   
    // Prepare data with services joined by comma for display
    const displayedQuotes = this.state.quoteData.map(item => {
      let servicesList = '';
      if (Array.isArray(item.rq_sm_id)) {
        servicesList = item.rq_sm_id.map(s => s.sm_title || s.name).join(', ');
      }
      return { ...item, servicesList };
    });

    // Paginate
 const paginatedQuotes = displayedQuotes;

    return (
      <div>
        <Typography variant="h5" gutterBottom>
          Request Quote Management
        </Typography>

        {/* Search inputs */}
        <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
          <TextField
            label="Name"
            name="searchName"
            value={this.state.searchName}
            onChange={this.handleInputChange}
            size="small"
          />
          <TextField
            label="Email"
            name="searchEmail"
            value={this.state.searchEmail}
            onChange={this.handleInputChange}
            size="small"
          />
          <TextField
            label="Phone"
            name="searchPhone"
            value={this.state.searchPhone}
            onChange={this.handleInputChange}
            size="small"
          />
          <TextField
  select
 
  name="searchService"
  value={this.state.searchService}
  onChange={this.handleInputChange}
  SelectProps={{ native: true }}
  size="small"
  style={{ minWidth: 180 }}
>
  <option value="">All Services</option>
  {Array.isArray(this.state.allServices) &&
    this.state.allServices.map(service => (
      <option key={service.sm_id} value={service.sm_title}>
        {service.sm_title}
      </option>
    ))}
</TextField>

          <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSearch}>
            Search
          </Button>
        </div>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Services</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.paginatedQuotes.length > 0 ? (
                this.state.paginatedQuotes.map((quote, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{quote.rq_name}</TableCell>
                    <TableCell>{quote.rq_emailid}</TableCell>
                    <TableCell>{quote.rq_phoneno}</TableCell>
                    <TableCell>{quote.servicesList}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No quote requests found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

         <TablePagination
              component="div"
              count={this.state.totalItems}
              page={this.state.page}
              onPageChange={this.handleChangePage}
              rowsPerPage={this.state.rowsPerPage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
              rowsPerPageOptions={this.state.itemsPerPageOptions}
            />
        </TableContainer>
      </div>
    );
  }
}

export default RequesatQuote;
